import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {HorribleHeroesLayerConfig} from "../config/IHorribleHeroesLayerConfig";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {HorribleHeroesParsedGameData} from "../server/data/HorribleHeroesParsedGameData";
import {HorribleHeroesParsedInitData} from "../server/data/HorribleHeroesParsedInitData";
import {HorribleHeroesEvents} from "../events/HorribleHeroesEvents";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineLite, TweenLite} from "gsap";
import {HorribleHeroesReelController} from "../reel/HorribleHeroesReelController";
import {HorribleHeroesGameModuleConfig} from "../HorribleHeroesGameModuleConfig";
import {SoundManager} from "../resource/sound/SoundManager";

export interface IStickyObject {
    isSticky: boolean,
    duration: number
}

export class StickyWildsView extends BaseView {
    private _layer: ScalableLayer;
    private _stickyContainer: PIXI.Container;
    private _glowContainer: PIXI.Container;
    private _gameData: HorribleHeroesParsedGameData | HorribleHeroesParsedInitData;
    private _imgPrefix: string = "swImg_";
    private _multPrefix: string = "multImg_";
    private _swContainerPrefix: string = "sw_cont_";
    private _glPrefix: string = "glow_cont_";
    private _glowPrefix: string = "wildLock";
    private _reelSize: number[] = [4, 4, 4, 4, 4];
    private _lockGlowAim: TimelineLite;
    private _wildLockTime: number = 0;
    private _isQuicktop: boolean = false;
    private _lockSpineAnim: PIXI.spine.Spine[][] = [];

    constructor() {
        super();
        this._layer = StageManager.getLayer(HorribleHeroesLayerConfig.STICKY_WILDS.name);
        this.reset();
    }

    /*playAnimation as soon as reel is quickstopped*/
    public setQuickstop(isQuicksTop: boolean): void {
        if (isQuicksTop && this._isQuicktop === isQuicksTop) {
            //already quickstopped;
            return;
        }
        //#556
        this._isQuicktop = isQuicksTop;
        if (this._isQuicktop) {
            //#553 #529
            this._lockSpineAnim.forEach((eachReelLockAnim, reelId) => {
                eachReelLockAnim.forEach((eachSpineItem: PIXI.spine.Spine) => {
                    if (eachSpineItem) {
                        const currReelId: number = parseInt(eachSpineItem.parent.name.replace(this._swContainerPrefix, "").split("_")[0], 10),
                            currSymId: number = parseInt(eachSpineItem.parent.name.replace(this._swContainerPrefix, "").split("_")[1], 10),
                            /*container index starts from 1 to subtract 1*/
                            trackEntry: PIXI.spine.core.TrackEntry = eachSpineItem.state.getCurrent(0);
                        //=> 0 is the track index at which animation was/is played
                        if (trackEntry) {
                            trackEntry.trackTime = trackEntry.animation.duration;
                            if (this._gameData instanceof HorribleHeroesParsedGameData) {
                                if (!this._gameData.isXWayExpanded[reelId]) {
                                    HorribleHeroesGameModuleConfig.scatterPlusOne.updateSpinButton(currReelId, currSymId - 1, false, true, 0);
                                    //+1animis shown on symHeightChanged
                                    //#556 not play if X lands on same reel
                                }
                            }
                        }
                        eachReelLockAnim.pop();
                    }
                });

            });


        }
    }

    public onSymHeightChange(reelId: number, symId: number, mSymbolSize: number, totalSymInReel: number, posY: number, showPlusFS?: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite({});
        if (this.isBonusGame()) {
            this._reelSize[reelId] = totalSymInReel;
            let wildSymContainer: PIXI.Container = (this._stickyContainer.getChildByName(this._swContainerPrefix + reelId + "_" + symId)) as PIXI.Container;
            let glowContainer: PIXI.Container = (this._glowContainer.getChildByName(this._glPrefix + reelId + "_" + symId)) as PIXI.Container;
            if (wildSymContainer) {
                if (wildSymContainer.visible) {
                    let spriteToHide: PIXI.Sprite = (wildSymContainer.getChildByName(this._imgPrefix + 4)) as PIXI.Sprite,
                        spriteToShow: PIXI.Sprite = (wildSymContainer.getChildByName(this._imgPrefix + totalSymInReel)) as PIXI.Sprite;
                    const symHeight = HorribleHeroesReelController.SYM_SIZE[totalSymInReel].height;
                    if (wildSymContainer.getChildAt(0).visible && showPlusFS) {
                        //#556  when X  + W  lands first time together
                        //playing +1FS before Xexpands
                        HorribleHeroesGameModuleConfig.scatterPlusOne.updateSpinButton(reelId, symId - 1, false, true, 0.1);
                    }
                    spriteToShow.alpha = 0;
                    spriteToHide.alpha = 1;
                    spriteToShow.scale.set(1, 148 / symHeight);
                    tl.add(TweenLite.to(wildSymContainer, 0.2, {y: posY}), 0);
                    tl.add(TweenLite.to(glowContainer, 0.2, {y: posY}), 0);
                    tl.add(TweenLite.to(spriteToHide, 0.3, {
                        alpha: 0, onComplete: () => {
                            spriteToHide.alpha = 1;
                        }
                    }), 0);
                    tl.add(TweenLite.to(spriteToShow.scale, 0.2, {y: 1}), 0);
                    tl.add(this.resetMask(glowContainer as PIXI.Container, totalSymInReel), 0);
                    tl.add(TweenLite.to(spriteToShow, 0.2, {
                        alpha: 1, onComplete: () => {
                            this.showSprite(spriteToShow, false, false);
                            this.hideSprite(spriteToHide);
                            wildSymContainer.position.y = posY;
                        }
                    }), 0);
                }
            }
        }
        return tl;
    }

    public reset(): void {
        if (this._stickyContainer) {
            this._stickyContainer.children.forEach((sw_container: PIXI.DisplayObject) => {
                if (sw_container.visible) {
                    this.hideAllSubChildren(<PIXI.Container>sw_container, true);
                    sw_container.visible = false;
                }
            });
            this.resetGlowAnimation();
        }
        if (this._glowContainer) {
            this._glowContainer.children.forEach((glowContainer: PIXI.DisplayObject) => {
                if (glowContainer.visible) {
                    glowContainer.visible = false;
                }
            });
        }
    }

    public holdOnGameRestore(): boolean {
        let stickyPos: boolean[][] = this.getStickyWildPositions(),
            reducedStickyPos: boolean[] = [],
            flag: boolean = false;

        if (stickyPos) {
            reducedStickyPos = stickyPos.reduce(function (prev, next) {
                return prev.concat(next);
            });
        }

        if (this.isRestore() && this.isBonusGame() && reducedStickyPos.length > 0 && reducedStickyPos.includes(true)) {
            flag = true;
        }

        return flag;
    }

    public isBonusGame(): boolean {
        let flag = false;
        if (HorribleHeroesGameConfig.instance.BONUS_MODES.indexOf(this._gameData.mode) > -1) {
            flag = true;
        }
        return flag;
    }

    public hasNewStickyWildLandedOnReel(reelId: number): boolean {
        let isSticky = false;
        if (this._gameData instanceof HorribleHeroesParsedGameData) {
            if (this._gameData!.bonusPositions[reelId] > -1) {
                isSticky = true;
            }
        }
        return isSticky;
    }

    public addDelayToReel(reelId: number): IStickyObject {
        const plus1AnimDuration: number = 1;
        //1 is duration of +1FS Animation
        const stickyObj: IStickyObject = {isSticky: false, duration: this._wildLockTime + plus1AnimDuration};
        if (HorribleHeroesGameModuleConfig.stickyWilds.isBonusGame()) {
            if (this._gameData instanceof HorribleHeroesParsedGameData) {
                const symId = this._gameData!.bonusPositions[reelId - 1];
                if (this._gameData!.bonusPositions[reelId - 1] > -1) {
                    stickyObj.isSticky = true;
                    if (this._gameData.wildMultipliers[reelId - 1][symId] > 1) {
                        stickyObj.isSticky = true;
                        const multiplierDuration = 0.5; //382;
                        stickyObj.duration = multiplierDuration + this._wildLockTime + plus1AnimDuration;
                        //#533
                    }
                }
            }
        }
        return stickyObj;
    }

    public showStickyWilds(reelId: number, isRestore?: boolean): TimelineLite {
        this._lockSpineAnim[reelId] = [];
        this._isQuicktop = false;
        //556 set for every Reel
        const tl: TimelineLite = new TimelineLite();
        // #420
        if (!isRestore) {
            HorribleHeroesGameModuleConfig.reelBackGroundView.updateXWays(reelId);
        }
        let stickyWildsPositions: boolean[][] = this.getStickyWildPositions();
        for (let symId: number = 0; symId < stickyWildsPositions[reelId].length; symId++) {
            if (stickyWildsPositions[reelId][symId]) {
                let sw_container: PIXI.Container = (this._stickyContainer.getChildByName(this._swContainerPrefix + reelId + "_" + (symId + 1))) as PIXI.Container;
                let defaultSprite: PIXI.Sprite;
                if (sw_container) {
                    if (!(sw_container.visible)) {
                        // #532
                        const pos: number[] = Helper.getSymbolPositionsOnReelArea(reelId, symId);
                        sw_container.position.set(pos[0], pos[1]);

                        sw_container.visible = true;
                        sw_container.children.forEach((item: PIXI.DisplayObject) => {
                            if (item instanceof PIXI.Sprite) {
                                if (!(defaultSprite && item.name === defaultSprite.name)) {
                                    this.hideSprite(item, isRestore);
                                }
                            }

                            if (item instanceof PIXI.spine.Spine) {
                                if (isRestore) {
                                    defaultSprite = sw_container.getChildByName(this._imgPrefix + "4") as PIXI.Sprite;
                                    if (defaultSprite) {
                                        tl.add(this.showSprite(defaultSprite, isRestore, false));
                                    }
                                } else {
                                    item.updateTransform();
                                    item.visible = true;
                                    item.state.clearTracks();
                                    item.state.setAnimation(0, "fsWildlock", false);
                                    //#529 //#533
                                    // #555 +1fs to be played after multiplier animation
                                    let showFSPlusAnim: boolean = true;
                                    if (this._gameData instanceof HorribleHeroesParsedGameData) {
                                        if (this._gameData.isXWayExpanded[reelId]) {
                                            showFSPlusAnim = false;
                                            //+1animis shown on symHeightChanged
                                            //#556
                                        }
                                    }
                                    item.state.addListener({
                                        complete: () => {
                                            if (!isRestore) {
                                                if (this._gameData.wildMultipliers[reelId][symId] === 1 && !this._isQuicktop && showFSPlusAnim) {
                                                    this._lockSpineAnim[reelId].pop();
                                                    HorribleHeroesGameModuleConfig.scatterPlusOne.updateSpinButton(reelId, symId, false, false, 0.2)
                                                } else {
                                                    this.showMultiplier(item.parent, isRestore, showFSPlusAnim);
                                                }
                                            }
                                            item.state.clearListeners();
                                        }
                                    });
                                    this._lockSpineAnim[reelId].push(item);
                                }
                            }
                        });
                    }
                }
            }
        }
        //#443 play for all reels
        this.playGlowAnimationForWilds();
        return tl;
    }

    public isRestore(): boolean {
        return ((this._gameData instanceof HorribleHeroesParsedInitData) && (this._gameData.isRestoreState));
    }

    public getNextMode(): string {
        if (this._gameData instanceof HorribleHeroesParsedInitData) {
            return (this._gameData.nextMode);
        } else {
            return (this._gameData.nextMode);
        }
    }

    public getStickyWildPositions(): boolean[][] {
        if (this.isRestore()) {
            return this._gameData.lockedWildWindow;
        } else {
            return this._gameData.lockedWildNextSpin;
        }
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, HorribleHeroesEvents.ON_GAME_START, () => this.onGameStart());
        EventHandler.addEventListener(this, SpinEvent.STARTED, () => this.onSpinStart());
    }

    protected initAnimations(): void {
        this._layer.position.set(0, HorribleHeroesGameConfig.instance.REEL_AREA_POS_Y);
        this.createGraphics();
    }

    //#443 wild HighLight to play for all reels
    private playGlowAnimationForWilds(): void {
        const stickyGlowitems: PIXI.Container[] = [];
        for (let reelId: number = 1; reelId < 4; reelId++) {
            let stickyWildsPositions: boolean[][] = this.getStickyWildPositions();
            for (let symId: number = 0; symId < stickyWildsPositions[reelId].length; symId++) {
                if (stickyWildsPositions[reelId][symId]) {
                    let sw_container: PIXI.Container = (this._stickyContainer.getChildByName(this._swContainerPrefix + reelId + "_" + (symId + 1))) as PIXI.Container;
                    let glow_container: PIXI.Container = (this._glowContainer.getChildByName(this._glPrefix + reelId + "_" + (symId + 1))) as PIXI.Container;
                    if (sw_container.visible) {
                        if (glow_container) {
                            // #532
                            glow_container.position.set(sw_container.x, sw_container.y);
                            this.resetMask(glow_container as PIXI.Container, this._reelSize[reelId]);

                            glow_container.visible = true;
                        }
                        stickyGlowitems.push(glow_container as PIXI.Container);
                    }
                }
            }
        }
        this.playGlowAnimation(stickyGlowitems);
    }

    private onGameDataParsed(data: HorribleHeroesParsedGameData | HorribleHeroesParsedInitData): void {
        this._gameData = data;
        if (data instanceof HorribleHeroesParsedInitData) {
            EventHandler.removeEventListener(this, ServerEvent.INIT_DATA_PARSED);
        }
    }

    private createGraphics(): void {
        this._stickyContainer = new PIXI.Container();
        this._glowContainer = new PIXI.Container();
        this._layer.addChild(this._glowContainer);
        this._glowContainer.name = this._glPrefix;
        this._stickyContainer.name = this._swContainerPrefix;
        this._layer.addChild(this._stickyContainer);
        //loop for middle reels 1,2 & 3 only
        for (let i: number = 3; i >= 1; i--) {
            //max sticky wild per reel is 4
            for (let j: number = 1; j <= 4; j++) {
                let stickyWildContainer: PIXI.Container = new PIXI.Container(),
                    symPositions: number[] = Helper.getSymbolPositionsOnReelArea(i, j - 1),
                    sw_spine: PIXI.spine.Spine = this.createSpine();

                stickyWildContainer.name = this._swContainerPrefix + i + "_" + j;
                stickyWildContainer.position.set(symPositions[0], symPositions[1]);
                stickyWildContainer.addChild(sw_spine);
                stickyWildContainer.visible = false;

                //sticky wild sizes w_4 to w_8
                for (let k: number = 4; k <= 8; k++) {
                    let sw_sprite: PIXI.Sprite = this.createSprite(k);
                    stickyWildContainer.addChild(sw_sprite);
                }

                //wild multiplier
                for (let q: number = 2; q <= 3; q++) {
                    let mult_sprite: PIXI.Sprite = this.createMultSprite(q);
                    stickyWildContainer.addChild(mult_sprite);
                }
                this._stickyContainer.addChild(stickyWildContainer);
                const glowContainer = this.createWildLockSprite();
                glowContainer.name = this._glPrefix + i + "_" + j;
                glowContainer.position.set(symPositions[0], symPositions[1]);
                this._glowContainer.addChild(glowContainer);
            }
        }
    }

    private createSpine(): PIXI.spine.Spine {
        let spineTexture: PIXI.spine.core.SkeletonData = GameResources.getSpineAsset("stickyWildSpine"),
            spine: PIXI.spine.Spine = new PIXI.spine.Spine(spineTexture);
        spine.visible = false;
        this._wildLockTime = spine.spineData.findAnimation("fsWildlock").duration;
        return spine;
    }

    private hideSpine(item: PIXI.spine.Spine): void {
        if (item.visible) {
            item.skeleton.setToSetupPose();
            item.state.clearTracks();
            item.visible = false;
        }
    }

    private showSprite(item: PIXI.Sprite, isRestore?: boolean, showPlusFS?: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let parentContainer: PIXI.Container = item.parent;
        this.hideAllSubChildren(parentContainer, false, item);
        item.visible = true;
        item.alpha = 1;
        tl.add(this.showMultiplier(parentContainer, isRestore, showPlusFS));
        return tl;
    }

    private showMultiplier(sw_container: PIXI.Container, isRestore?: boolean, showPlusFS?: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let parentContainer: PIXI.Container = sw_container,
            reelId: number = parseInt(parentContainer.name.replace(this._swContainerPrefix, "").split("_")[0], 10),
            indexAt: number = (this._stickyContainer.getChildIndex(parentContainer) % 4),
            multValue: number = this._gameData.wildMultipliers[reelId][indexAt],
            symScaling: { [reelSize: number]: number } = {
                4: 1,
                5: 0.9,
                6: 0.8,
                7: 0.7,
                8: 0.6
            },
            scalingFactor: number = symScaling[this._reelSize[reelId]];

        if (multValue > 1) {

            let multImg: PIXI.Sprite = (parentContainer.getChildByName(this._multPrefix + multValue)) as PIXI.Sprite;
            if (multImg.visible || isRestore) {
                multImg.visible = true;
                multImg.scale.set(scalingFactor);
            } else {
                multImg.scale.set(scalingFactor);
                let spineTexture: PIXI.spine.core.SkeletonData = GameResources.getSpineAsset("wildMult"),
                    multAnim: PIXI.spine.Spine = new PIXI.spine.Spine(spineTexture);
                if (multImg.children.length > 1) {
                    multImg.removeChildren();
                }
                multImg.addChild(multAnim);
                multImg.visible = true;
                //duration is 0.5;
                //line no 190
                multAnim.updateTransform();
                multAnim.visible = true;
                multAnim.state.clearTracks();
                multAnim.state.setAnimation(0, "x" + multValue, false);
                multAnim.state.addListener({
                    complete: () => {
                        if (!isRestore && showPlusFS && !this._isQuicktop) {
                            //#529 after stickylockup anim +multplier
                            //#555
                            this._lockSpineAnim[reelId].pop();
                            HorribleHeroesGameModuleConfig.scatterPlusOne.updateSpinButton(reelId, indexAt, false, false, 0.1);
                        }
                        multAnim.state.clearListeners();
                    }
                });


                // #537
                if (!isRestore) {
                    SoundManager.playFSWildMultiplier();
                }
            }
        }
        return tl;
    }

    private hideSprite(item: PIXI.Sprite, isRestore?: boolean): void {
        if (item.visible) {
            if (item.name.indexOf(this._multPrefix) !== -1) {
                if (item.children.length > 0) {
                    item.removeChildren();
                }
            }
            if (!isRestore) {
                item.visible = false;
            }
        }
    }

    private createSprite(symHeight: number): PIXI.Sprite {
        let spriteTexture: PIXI.Texture = GameResources.getTextures("sw_" + symHeight)[0],
            sprite: PIXI.Sprite = new PIXI.Sprite(spriteTexture);

        sprite.anchor.set(0.5);
        sprite.name = this._imgPrefix + symHeight;
        sprite.visible = false;
        return sprite;
    }

    private createMultSprite(multiplier: number): PIXI.Sprite {
        let spriteTexture: PIXI.Texture = GameResources.getTextures("wm_" + multiplier)[0],
            sprite: PIXI.Sprite = new PIXI.Sprite(spriteTexture);

        sprite.anchor.set(0.5);
        sprite.name = this._multPrefix + multiplier;
        sprite.visible = false;
        return sprite;
    }

    private createWildLockSprite(): PIXI.Container {
        const glowContainer: PIXI.Container = new PIXI.Container();
        const glowTop = this.createGlowSprite(this._glowPrefix, "top");
        const glowRight = this.createGlowSprite(this._glowPrefix, "right");
        const glowLeft = this.createGlowSprite(this._glowPrefix, "left");
        const glowBottom = this.createGlowSprite(this._glowPrefix, "bottom");

        glowContainer.addChild(glowTop, glowRight, glowLeft, glowBottom);
        glowTop.visible = true;
        glowRight.visible = true;
        glowLeft.visible = true;
        glowBottom.visible = true;
        glowContainer.visible = false;
        glowLeft.scale.x = 1.1;
        glowRight.scale.x = 1.15;

        this.resetMask(glowContainer, 4);
        return glowContainer;
    }

    private resetMask(glowContainer: PIXI.Container, totalSymInReel: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const height = HorribleHeroesReelController.SYM_SIZE[totalSymInReel].height;
        const scale = HorribleHeroesReelController.SYM_SIZE[totalSymInReel].height / 147;
        const glowTop = glowContainer.getChildByName(this._glowPrefix + "top");//.y  =-height/2 ;
        const glowRight = glowContainer.getChildByName(this._glowPrefix + "right");//.x  =75;
        const glowLeft = glowContainer.getChildByName(this._glowPrefix + "left");//.x  =-75;
        const glowBottom = glowContainer.getChildByName(this._glowPrefix + "bottom");//.x  =height/2;

        glowRight.rotation = 1.5708;
        glowLeft.rotation = 1.5708;
        glowLeft.scale.x = scale + 0.1;
        glowRight.scale.x = scale + 0.1;
        //glowTop.y = -(height / 2) - 5;
        glowRight.x = 75;
        glowLeft.x = -75;
        glowLeft.y = 3;
        glowRight.y = 3;
        //glowBottom.y = (height / 2) + 5;
        glowTop.scale.x = 1.05;
        glowBottom.scale.x = 1.05;
        tl.to(glowTop, 0.15, {y: -(height / 2) - 5}, 0);
        tl.to(glowBottom, 0.15, {y: (height / 2) + 5}, 0);

        return tl;
    }

    private createGlowSprite(resource: string, type: string): PIXI.Sprite {
        let spriteTexture: PIXI.Texture = GameResources.getTextures(resource)[0],
            sprite: PIXI.Sprite = new PIXI.Sprite(spriteTexture);

        sprite.anchor.set(0.5);
        sprite.name = resource + type;
        sprite.visible = true;
        return sprite
    }

    private onGameStart(): void {
        if (this.isBonusGame() && this.isRestore()) {
            let stickyWildsPositions: boolean[][] = this.getStickyWildPositions();
            for (let reelId: number = 1; reelId < stickyWildsPositions.length - 1; reelId++) {
                this.showStickyWilds(reelId, this.isRestore());
            }
        }
    }

    private playGlowAnimation(glowContainers: PIXI.Container[]): void {
        if (this._lockGlowAim) {
            this._lockGlowAim.pause();
            this._lockGlowAim.kill();
            this._lockGlowAim.clear();
        }
        this._lockGlowAim = new TimelineLite({
            onComplete: () => {
                this._lockGlowAim.restart();
            }
        });

        let delay = 0.67;
        this._lockGlowAim.add(() => {
            this.playEffect(glowContainers);
        }, 0);
        this._lockGlowAim.add(() => {
        }, delay);
    }

    private playEffect(glowContainers: PIXI.Container[]): void {
        const tl = new TimelineLite({
            onComplete: () => {
                tl.pause();
                tl.kill();
                tl.clear();
            }
        });

        for (let i = 0; i < glowContainers.length; i++) {
            TweenLite.to(glowContainers[i], 0.33, {alpha: 0.65});
            tl.add(() => {
                TweenLite.to(glowContainers[i], 0.33, {alpha: 1});
            }, 0.33);
        }
    }

    private onSpinStart(): void {
        if (this.isBonusGame()) {
            this._reelSize = [4, 4, 4, 4, 4];
            this._stickyContainer.children.forEach((sw_container: PIXI.DisplayObject) => {
                let name = sw_container.name.split("_");
                let reelID = name[2];
                let symId = name[3];
                let glow_container = this._glowContainer.getChildByName(this._glPrefix + reelID + "_" + symId);
                if (sw_container.visible) {
                    let containerName: string = sw_container.name,
                        currReelId: number = parseInt(containerName.replace(this._swContainerPrefix, "").split("_")[0], 10),
                        currSymId: number = parseInt(containerName.replace(this._swContainerPrefix, "").split("_")[1], 10),
                        defaultSprite: PIXI.Sprite = ((<PIXI.Container>sw_container).getChildByName(this._imgPrefix + 4)) as PIXI.Sprite,
                        symPositions: number[] = Helper.getSymbolPositionsOnReelArea(currReelId, currSymId - 1);
                    this.resetMask(glow_container as PIXI.Container, this._reelSize[currReelId]);
                    this.hideAllSubChildren((<PIXI.Container>sw_container), false, defaultSprite);
                    this.showSprite(defaultSprite, false, false);
                    sw_container.x = symPositions[0];
                    glow_container.x = symPositions[0];
                    TweenLite.to(glow_container, 0.2, {y: symPositions[1]});
                    TweenLite.to(sw_container, 0.2, {
                        y: symPositions[1], onComplete: () => {
                            sw_container.position.set(symPositions[0], symPositions[1]);
                        }
                    });
                }
            });
        }
    }

    private hideAllSubChildren(sw_container: PIXI.Container, hideMultipliers: boolean, toShow?: PIXI.Sprite): void {
        sw_container.children.forEach((item: PIXI.DisplayObject) => {
            if (item instanceof PIXI.Sprite) {
                if (item.name.indexOf(this._multPrefix) === -1) {
                    if (!(toShow && (toShow.name === item.name))) {
                        this.hideSprite(item)
                    }
                } else {
                    if (hideMultipliers) {
                        this.hideSprite(item);
                    }
                }
            }
            if (item instanceof PIXI.spine.Spine) {
                this.hideSpine(item);
            }
        });
    }

    private resetGlowAnimation(): void {
        if (this._lockGlowAim) {
            this._lockGlowAim.pause();
            this._lockGlowAim.kill();
            this._lockGlowAim.clear();
        }
    }
}